import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=37c3ce62"
import script from "./Base.vue?vue&type=script&lang=js"
export * from "./Base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports